import {
  GET_EMPLOYEE_CATEGORIES,
  DELETE_EMPLOYEE_CATEGORY,
  FETCH_EMPLOYEE_CATEGORY,
  EDIT_EMPLOYEE_CATEGORY,
  ADD_EMPLOYEE_CATEGORY,
  CLEAR_EMPLOYEE_CATEGORY,
  CLEAR_ALL,
  GET_EMPLOYEE_ORG_CATEGORIES,
  GET_EMPLOYEE_USER_CATEGORIES,
  CLEAR_EMPLOYEE_ORG_CATEGORY,
  ADD_EDIT_MANAGER_USER,
  EMPLOYEE_CATEGORY_SEARCH_PENDING,
  EMPLOYEE_CATEGORY_SEARCH_SUCCESS,
  EMPLOYEE_CATEGORY_SEARCH_FAILURE,
} from "constants/actions";

const initialState = {
  employee_category: [],
  employee_org_category: [],
  employee_org_category_pagination: {
    count: 0,
    next: null,
    previous: null,
  },
  employee_user_category: [],
  manager_categories: [],
  pending: false,
  created: false,
  fetched: false,
  search: {
    pending: false,
    error: null,
    filters: null,   // raw filters object (excluding page / page_size / ordering)
    ordering: null,  // e.g. "-updated_at" or "employee__first_name"
    page: 1,
    page_size: 50,
    count: 0,
    next: null,
    previous: null,
    results: [],     // raw `results` from API (EmployeeCategory list)
  },
};

export default function EmployeeCategories(state = initialState, action) {
  switch (action.type) {
    case GET_EMPLOYEE_CATEGORIES:
      return {
        ...state,
        employee_category: action.payload,
        pending: false,
        created: false,
      };

    case FETCH_EMPLOYEE_CATEGORY:
      return {
        ...state,
        [action.payload.id]: action.payload,
        pending: false,
        created: false,
      };

    case EDIT_EMPLOYEE_CATEGORY:
      if (
        state.employee_category.filter((an) => an.id === action.payload.id)[0]
      ) {
        state = {
          ...state,
          employee_category: state.employee_category.filter(
            (rw) => rw.id !== action.payload.id
          ),
        };
      }
      return {
        ...state,
        created: false,
        employee_category: [...state.employee_category, action.payload],
      };

    case ADD_EDIT_MANAGER_USER:
      const empCategoryCopy = [...state.employee_org_category];
      const updatedEmpCategory = empCategoryCopy.map((emp) => {
        const data = action.payload.find(
          (d) => d.employee_id === emp.employee_id
        );
        if (data) {
          emp.category.push(data.employee_category);
        }
        return emp;
      });

      return {
        ...state,
        employee_org_category: updatedEmpCategory,
        manager_categories: action.payload,
        created: false,
      };

    case GET_EMPLOYEE_ORG_CATEGORIES:
      return {
        ...state,
        employee_org_category: action.payload?.results || [],
        employee_org_category_pagination: {
          count: action.payload?.count || 0,
          next: action.payload?.next || null,
          previous: action.payload?.previous || null,
        },
        pending: false,
        created: false,
        fetched: true,
      };

    case CLEAR_EMPLOYEE_ORG_CATEGORY:
      return {
        ...state,
        employee_org_category: [],
        created: false,
      };

    case GET_EMPLOYEE_USER_CATEGORIES:
      return {
        ...state,
        employee_user_category: action.payload,
        pending: false,
        created: false,
      };

    case DELETE_EMPLOYEE_CATEGORY:
      // console.log(action.payload)
      return {
        ...state,
        employee_category: state.employee_category.filter(
          (row) => row.id !== action.payload.id
        ),
      };

    case ADD_EMPLOYEE_CATEGORY:
      // const newState = state.employee_category
      // newState.push(action.payload)
      return {
        ...state,
        created: action.payload,
        employee_category: [...state.employee_category, action.payload],
      };

    case CLEAR_EMPLOYEE_CATEGORY:
      return {
        ...state,
        employee_category: [],
        created: false,
      };

    case CLEAR_ALL:
      return {
        ...state,
        employee_category: [],
        employee_org_category: [],
        employee_user_category: [],
        created: false,
      };

    case EMPLOYEE_CATEGORY_SEARCH_PENDING:
      return {
        ...state,
        search: {
          ...state.search,
          pending: true,
          error: null,
        },
      };

    case EMPLOYEE_CATEGORY_SEARCH_SUCCESS: {
      const { data, filters, ordering, page, page_size } = action.payload || {};
      return {
        ...state,
        search: {
          ...state.search,
          pending: false,
          error: null,
          filters: filters || null,
          ordering: ordering || null,
          page: page || 1,
          page_size: page_size || state.search.page_size,
          count: data?.count ?? 0,
          next: data?.next || null,
          previous: data?.previous || null,
          results: Array.isArray(data?.results) ? data.results : [],
        },
      };
    }

    case EMPLOYEE_CATEGORY_SEARCH_FAILURE:
      return {
        ...state,
        search: {
          ...state.search,
          pending: false,
          error: action.payload || "Unable to fetch employee categories",
        },
      };

    default:
      return state;
  }
}
